import Concorrente from '../../spa/concorrente/ConcorrenteCadastro';

export default {
  path: 'concorrente',
  name: 'concorrente',
  component: Concorrente,
};
